ignoreErrors